// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { iconsSharedStyles } from "@eisinc/App/SharedStyles/IconsStyles";
import { orderApprovalDetailsActionButtonsStyles } from "@eisinc/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import { modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.deleteButton =
    orderApprovalDetailsActionButtonsStyles.showActivityLogButton =
    orderApprovalDetailsActionButtonsStyles.continueShoppingButton =
    orderApprovalDetailsActionButtonsStyles.approveButton =
    orderApprovalDetailsActionButtonsStyles.printButton =
    orderApprovalDetailsActionButtonsStyles.editButton =
    orderApprovalDetailsActionButtonsStyles.requestRevisionButton =
        {
            css: css`
                ${iconsSharedStyles}
            `,
        };

orderApprovalDetailsActionButtonsStyles.buttonWrapper = {
    css: css`
        display: flex;
        gap: 30px;
    `,
};

orderApprovalDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
        gap: 30px;
    `,
};

orderApprovalDetailsActionButtonsStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            width: 100%;
            max-width: 30px;
        `,
    },
    buttonProps: {
        variant: "secondary",
        css: css`
            max-width: 100%;
        `,
    },
};

orderApprovalDetailsActionButtonsStyles.twoButtonModalStyles = {
    cancelButton: {
        variant: "secondary",
    },
    submitButton: {
        variant: "tertiary",
    },
};

orderApprovalDetailsActionButtonsStyles.iconStyle = {
    size: 16,
    color: "primary.main",
    css: css`
        margin-right: 5px;
    `,
};

orderApprovalDetailsActionButtonsStyles.requestRevisionButtonsGridItem = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

orderApprovalDetailsActionButtonsStyles.requestRevisionCancelButton = { ...modalButtonsActionStyles.cancelButton };

orderApprovalDetailsActionButtonsStyles.requestRevisionSendRequestButton = { ...modalButtonsActionStyles.submitButton };
